import { gql } from "@apollo/client";

export const COMPUTE_QUOTATIONS = gql`
  mutation computeQuotations($input: ComputeQuotationsInput!) {
    computeQuotations(input: $input) {
      commandId
      correlationId
    }
  }
`;
